import { render } from "./GameSelection.vue?vue&type=template&id=568ae0c4"
import script from "./GameSelection.vue?vue&type=script&lang=js"
export * from "./GameSelection.vue?vue&type=script&lang=js"

import "./GameSelection.vue?vue&type=style&index=0&id=568ae0c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__